import { showToast } from '@provi/provi-components'
import { captureEvent } from '../../../utils/posthog'
import { POSTHOG_EVENTS } from '../../../constants/posthog'
import { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router'

import { MODE_DASH } from '../../../constants'
import { history } from '../../../navigation/history'
import { getFinancingInvoices, getInvoiceUnique, getDuplicateInvoice } from '../../../services/api'

export const useInvoices = (setMenuActive, setIsBack, setIsLoading, selectCrid, typeDash) => {
  const { status } = useParams()
  const [invoice, setInvoice] = useState([])
  const [renegotiation, setRenegotiation] = useState({ canRenegotiate: false, delayedInstallments: 0 })
  const toggle = status === 'pagas' ? 'paid' : 'open'

  const handleToggle = useCallback(
    toggleStatus => {
      if (toggleStatus === 'paid') history.push('/dashboard/faturas/pagas')
      else history.push('/dashboard/faturas/abertas')
    },
    [toggle]
  )

  const getData = useCallback(
    async id => {
      setIsLoading(true)
      try {
        const response = await getFinancingInvoices(id)
        const responseData = response.data || response
        const metadata = response.metadata

        const renegotiationData = responseData.renegotiation || { canRenegotiate: false, delayedInstallments: 0 }
        setRenegotiation(renegotiationData)

        if (typeDash === MODE_DASH.allowance) {
          const invoicesObj = responseData.invoices || {}
          const invoicesList = Array.isArray(invoicesObj) ? invoicesObj : invoicesObj.invoices || []
          setInvoice(invoicesList)
        } else {
          const { invoices } = responseData
          setInvoice(Array.isArray(invoices) ? invoices : [])
        }

        captureEvent(POSTHOG_EVENTS.MINHAS_FATURAS_ACESSADAS, {
          numero_pedido_compra: String(id),
          qtd_parcelas_em_aberto: metadata?.openCount,
          qtd_parcelas_em_atraso: metadata?.overdueCount,
          valor_total_em_aberto: metadata?.totalOpen,
          valor_total_em_atraso: metadata?.totalOverdue,
          possui_proposta_ativa: renegotiationData.canRenegotiate ? false : true,
          dias_atraso: metadata?.maxDaysOverdue,
        })
      } catch (err) {
        if (err?.response?.status !== 401) {
          showToast('Error, por favor tente novamente')
        }
      } finally {
        setIsLoading(false)
      }
    },
    [setIsLoading, typeDash]
  )

  useEffect(() => {
    if (selectCrid) {
      getData(selectCrid.id)
    } else {
      history.push('/inicio')
    }

    setMenuActive('invoices')
    setIsBack(true)
  }, [getData, selectCrid, setIsBack, setIsLoading, setMenuActive])

  const getInvoice = async item => {
    if (item.status === 'delayed' && item.InvoiceId) {
      try {
        setIsLoading(true)
        const { data: dataDuplicateInvoice } = await getDuplicateInvoice(item)
        window.open(dataDuplicateInvoice.url, '_blank')
        getData(selectCrid.id)
      } catch (err) {
        if (err.response) {
          showToast(err.response.data.message)
          return
        }
        showToast()
      } finally {
        setIsLoading(false)
      }
    } else {
      if (item.url) {
        window.open(item.url, '_blank')
        return
      }

      try {
        setIsLoading(true)
        const { data: dataInvoice } = await getInvoiceUnique(item)
        window.open(dataInvoice.url, '_blank')
        getData(selectCrid.id)
      } catch (err) {
        if (err.response) {
          showToast(err.response.data.message)
          return
        }
        showToast()
      } finally {
        setIsLoading(false)
      }
    }
  }

  return [invoice, toggle, handleToggle, getInvoice, renegotiation]
}
